// Корзина живёт в sessionStorage: она НЕ должна переживать закрытие миниаппа —
// при следующем заходе витрина открывается пустой (уведомление о неоплаченной
// корзине шлёт бот отдельно, по PaymentAttempt, оно от этого не зависит).
// Переход index ↔ cart корзину не теряет: состав едет в адресе (см. withCart),
// а sessionStorage — общий на вкладку в рамках одной сессии миниаппа.
//
// welcome-seen, наоборот, должен помниться между заходами → он в localStorage.
//
// Ключ всегда со слагом магазина: сеть живёт на одном origin (?tenant=slug),
// иначе корзины разных магазинов смешиваются (чужие id — оплатить нельзя).
import { tenantSlug } from './tg';

export interface CartItem {
  id: number;
  name: string;
  price: number;
  category?: string;
}

/** Ключ всегда со слагом магазина — иначе корзины магазинов сети смешиваются. */
function key(name: string): string {
  return `${name}:${tenantSlug()}`;
}

function read<T>(store: Storage, name: string, fallback: T): T {
  try {
    const raw = store.getItem(key(name));
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback; // приватный режим или битый JSON
  }
}

function write(store: Storage, name: string, value: unknown): void {
  try {
    store.setItem(key(name), JSON.stringify(value));
  } catch {
    /* приватный режим — проживёт в памяти страницы */
  }
}

export function getCart(): CartItem[] {
  const cart = read<CartItem[]>(sessionStorage, 'cart', []);
  return Array.isArray(cart) ? cart : [];
}

export function setCart(cart: CartItem[]): void {
  write(sessionStorage, 'cart', cart);
}

export function cartIds(): number[] {
  return getCart()
    .map((it) => it.id)
    .filter((x): x is number => typeof x === 'number');
}

export function inCart(id: number): boolean {
  return getCart().some((it) => it.id === id);
}

/** Добавляет или убирает тариф. Возвращает состояние ПОСЛЕ переключения. */
export function toggleCartItem(item: CartItem): boolean {
  const cart = getCart();
  const idx = cart.findIndex((it) => it.id === item.id);
  if (idx > -1) cart.splice(idx, 1);
  else cart.push(item);
  setCart(cart);
  return idx === -1;
}

export function addToCart(item: CartItem): void {
  if (!inCart(item.id)) setCart([...getCart(), item]);
}

export function removeAt(index: number): void {
  const cart = getCart();
  cart.splice(index, 1);
  setCart(cart);
}

export function welcomeSeen(): boolean {
  return read<boolean>(localStorage, 'welcome-seen', false) === true;
}

export function markWelcomeSeen(): void {
  write(localStorage, 'welcome-seen', true);
}
